import React, { useEffect, useState } from 'react';

interface ChallengeTimerProps {
  timeoutSeconds: number;
  size?: number;
}

export const ChallengeTimer: React.FC<ChallengeTimerProps> = ({
  timeoutSeconds,
  size = 128,
}) => {
  const [timeLeft, setTimeLeft] = useState(timeoutSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => Math.max(prev - 0.1, 0));
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const progress = (timeLeft / timeoutSeconds) * 100;
  const radius = size * 0.35;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  let color = '#10b981';
  if (progress <= 67 && progress > 33) {
    color = '#f59e0b';
  } else if (progress <= 33) {
    color = '#ef4444';
  }

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg className="w-full h-full" style={{ transform: 'rotate(-90deg)' }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#374151"
          strokeWidth="4"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.1s linear, stroke 0.3s' }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className="font-bold text-white"
          style={{ fontSize: Math.max(18, Math.round(size * 0.24)) }}
        >
          {Math.ceil(timeLeft)}
        </span>
      </div>
    </div>
  );
};
